import { GeneratePocScriptErrorSchema } from './findings.schemas';

export const POC_SCRIPT_MIME_TYPE = 'text/x-python';

type GeneratePocScriptErrorBodyCandidate =
  | { message?: string }
  | null
  | undefined;

export function getGeneratePocScriptErrorMessage(
  body: GeneratePocScriptErrorBodyCandidate,
  fallback: string,
): string {
  const parsed = GeneratePocScriptErrorSchema.safeParse(body);
  return parsed.success ? parsed.data.message : fallback;
}

export function getPocScriptDownloadFilename({
  findingId,
}: {
  findingId: string;
}): string {
  return `finding-${findingId}-poc.py`;
}
